import { createContext } from 'react';
import { decorate, observable, computed } from 'mobx';

export class Fetcher {

  loading = false;
  data = false;
  status = true;
  expireToken = false;

  setLoading = ({loading, status, data}) => {
    this.loading = loading;
    this.status = status;
    this.data = status ? data : false;
    this.expireToken = data.json.status === 203 ? true : false;
  }

}

decorate(Fetcher, {
  loading: observable,
  data: observable,
  status: observable,
  expireToken: observable,
})


export default createContext(new Fetcher())
